import { useRef } from 'react'
import { Container } from 'typescript-ioc/es5'
import { AppState } from '../../stores/app'
import { AppService, AuthService } from '../../services'

/**
 * Returns a stable reference to AppState from the IoC container.
 * Replaces the repeated `useRef(Container.get(AppState)).current` pattern.
 */
export function useAppState(): AppState {
    return useRef(Container.get(AppState)).current
}

/**
 * Returns a stable reference to AppService from the IoC container.
 */
export function useAppService(): AppService {
    return useRef(Container.get(AppService)).current
}

/**
 * Returns a stable reference to AuthService from the IoC container.
 */
export function useAuthService(): AuthService {
    return useRef(Container.get(AuthService)).current
}

/**
 * Generic hook for resolving any IoC-registered service.
 * Use the named hooks (useAppState, useAppService) when available
 * for better discoverability. Use this for one-off services.
 */
export function useMobileService<T>(ServiceClass: new (...args: any[]) => T): T {
    return useRef(Container.get(ServiceClass)).current
}
